export class InputData {
    dataElementId: string;
    dataElementLabel: string;
    dataElementValue: any;
    dataElementDisplayValue: any;
    constructor() {
        this.dataElementLabel = '';
        this.dataElementDisplayValue = '';

    }
}
